import {
    FETCH_ENCOUNTERS_REQUEST, FETCH_ENCOUNTERS_SUCCESS, FETCH_ENCOUNTERS_FAILURE,
    CREATE_ENCOUNTER_SUCCESS, UPDATE_ENCOUNTER_SUCCESS, DELETE_ENCOUNTER_SUCCESS
  } from '../actions/encounterActions';
  
  const initialState = {
    encounters: [],
    loading: false,
    error: null,
  };
  
  export default function encounterReducer(state = initialState, action) {
    switch (action.type) {
      case FETCH_ENCOUNTERS_REQUEST:
        return { ...state, loading: true };
      case FETCH_ENCOUNTERS_SUCCESS:
        return { ...state, loading: false, encounters: action.payload };
      case FETCH_ENCOUNTERS_FAILURE:
        return { ...state, loading: false, error: action.payload };
      case CREATE_ENCOUNTER_SUCCESS:
        return { ...state, encounters: [...state.encounters, action.payload] };
      case UPDATE_ENCOUNTER_SUCCESS:
        return {
          ...state,
          encounters: state.encounters.map((encounter) =>
            encounter.id === action.payload.id ? action.payload : encounter
          ),
        };
      case DELETE_ENCOUNTER_SUCCESS:
        return {
          ...state,
          encounters: state.encounters.filter((encounter) => encounter.id !== action.payload),
        };
      default:
        return state;
    }
  }
  